@if (showSkeleton()) {

} @else {
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
      <div class="col-lg-6 py-3">
        @if(balance?.apartment) {
          <div class="d-flex gap-2">
            <i class="bi bi-building fs-2 me-2"></i>
            <div>
              <div>{{ balance?.renter | renterName }} | {{ 'RESIDENTS.APARTMENT' | translate }} |
                {{ balance.apartment.floorName ? (('APARTMENT.FloorName.' + balance.apartment.floorName) | translate) : '' }} /
                {{ balance.apartment.floorDirection ? (('APARTMENT.FloorDirection.' + balance.apartment.floorDirection) | translate) : '' }}
              </div>
              <div>{{ balance.apartment?.building?.address  }}</div>
            </div>
          </div>
        }
      </div>
      <div class="col-lg-6 py-3 text-end">
        @if(contractLoading()) {
          <p-skeleton height="50px"></p-skeleton>
        } @else {
          <div class="text-muted small">
            @for(field of contractPaymentFields; track field; let odd = $odd) {
              @if(odd) {
                / {{ field.label | translate }} {{ contract[field.id] | moneyFormat }} <br>
              } @else {
                {{ field.label | translate }} {{ contract[field.id] | moneyFormat }}
              }
            }
          </div>
        }
      </div>
      <div class="col-lg-12">
        <div class="card card-bg">
          <div class="card-body">
            <h5>{{ 'BALANCE.RENT_PAYMENT_FOR' | translate: { date: periodTitle } }}</h5>
            <div class="row">
              <div class="col-lg-7">
                <p-calendar
                  [label]="'BALANCE.RECEIVED_ON' | translate"
                  formControlName="date"
                  inputValidator
                  [showIcon]="true"
                  iconDisplay="input"
                />
              </div>
              <div class="col-lg-5">
                <p-inputNumber
                  [maxFractionDigits]="5"
                  [minFractionDigits]="0"
                  [useGrouping]="false"
                  class="w-100"
                  formControlName="amount"
                  inputStyleClass="form-control"
                  inputValidator
                  [label]="'BALANCE.TOTAL_RENT_FOR' | translate: { date: periodTitle }"
                  mode="decimal"
                  styleClass="w-100"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-7">
                <ng-select
                  [clearable]="false"
                  [items]="paymentTypes"
                  formControlName="type"
                  inputValidator
                  label="PAYMENT.PAYMENT_TYPE"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <span>{{ "PAYMENT.TYPES." + item | translate }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                    <span>{{ "PAYMENT.TYPES." + item | translate }}</span>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end d-flex gap-2 justify-content-end">
        <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
        <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
      </div>
    </div>
  </form>
}
